import React, { Fragment, useId } from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

interface ITooltipLabel {
    text: string | React.ReactNode;
    content: string;
    delayOnShow?: number;
    className?: string;
}

export const TooltipLabel = ({ text, content, delayOnShow = 500, className = "d-block" }: ITooltipLabel): React.ReactElement => {
    const tooltipId = useId();
    return (
        <Fragment>
            <span className={className} data-tooltip-id={tooltipId} data-tooltip-delay-show={delayOnShow} style={{ cursor: "pointer" }}>
                {text}
            </span>
            <Tooltip id={tooltipId} content={content} style={{ maxWidth: "300px", whiteSpace: "pre-line" }} />
        </Fragment>
    );
};
